__turbopack_context__.v({
  "stub": "SectionStub-module-scss-module__VQ-wyq__stub",
  "stub--band": "SectionStub-module-scss-module__VQ-wyq__stub--band",
  "stub--lg": "SectionStub-module-scss-module__VQ-wyq__stub--lg",
  "stub--md": "SectionStub-module-scss-module__VQ-wyq__stub--md",
  "stub--sm": "SectionStub-module-scss-module__VQ-wyq__stub--sm",
  "stub--tile": "SectionStub-module-scss-module__VQ-wyq__stub--tile",
  "stub__label": "SectionStub-module-scss-module__VQ-wyq__stub__label",
  "stub__note": "SectionStub-module-scss-module__VQ-wyq__stub__note",
});
